import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import CardDetail from "components/CardDetail";
import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import LoadingSpin from "components/Loading";
import ScrollUpBtn from "components/ScrollUpBtn";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  NameCourse,
  SubDetail,
  SubHead,
  SubTitle,
  TextBold,
  TextName,
  TextNote,
  Title,
  TitleEN,
  View,
} from "./nursing.style";

import stuView from "assets/images/png/student_comp-01.png";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

function NursingDepartment({ selectYear, year }) {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`,
      { incrementVisitor: true }
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const renderDetailLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <DetailLink bottom="0" color={ListColor1[slang]}>
          {name}
        </DetailLink>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} />
        </div>

        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>
                            {" "}
                            {breadcrumbName[item]}
                          </Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>
            {windowWidth <= 1280
              ? departmentData?.message && (
                <Row className="row-title">
                  <Col span={12}>
                    <BlockName row={3}>
                      <img
                        loading="lazy"
                        src={listImage1[slang]}
                        alt="icon title"
                        style={{ maxWidth: "104px", width: "100%" }}
                      />

                      <TextName>
                        {splitName(departmentData?.message?.title, 0)}
                        <span>
                          {splitName(departmentData?.message?.title, 1, true)}
                        </span>
                      </TextName>
                    </BlockName>

                    <div className="col-image-profile">
                      <FadeInSection axis="y">
                        <img
                          loading="lazy"
                          src={
                            departmentData?.message?.image &&
                            departmentData?.message?.image[0]?.image_0
                          }
                          alt="dean"
                          style={{ marginTop: "20px", width: "100%" }}
                        />
                      </FadeInSection>
                    </div>

                    {departmentData?.message?.text &&
                      departmentData?.message?.text.map((item) => {
                        return (
                          <>

                            {item?.text_0 && (
                              <DetailTop>{item?.text_0}</DetailTop>
                            )}
                            {item?.text_1 && (
                              <DetailBottom>{item?.text_1}</DetailBottom>
                            )}
                            {item?.text_2 && (
                              <DetailBottom>{item?.text_2}</DetailBottom>
                            )}
                            {item?.text_3 && (
                              <DetailBottom>{item?.text_3}</DetailBottom>
                            )}
                          </>
                        );
                      })}
                  </Col>

                  {departmentData?.message?.image &&
                    departmentData?.message?.image.map((item) => {
                      return (
                        <>
                          <Col
                            span={11}
                            offset={1}
                            style={{
                              display: "flex",
                              alignItems: "baseline",
                            }}
                            className="col-image-profile"
                          ></Col>
                          {item?.image_1 && item?.image_2 && (
                            <Player
                              poster={item?.image_1}
                              className="img-people"
                              autoPlay
                              muted
                              playsInline
                              src={item?.image_2}
                            >
                              <BigPlayButton position="center" />
                            </Player>
                          )}
                        </>
                      );
                    })}
                </Row>
              )
              : departmentData?.message && (
                <Row className="row-title">
                  <Col span={12}>
                    <BlockName row={3}>
                      <img
                        loading="lazy"
                        src={listImage1[slang]}
                        alt="icon title"
                        style={{ width: "104px" }}
                      />

                      <TextName>
                        {splitName(departmentData?.message?.title, 0)}
                        <span>
                          {splitName(departmentData?.message?.title, 1, true)}
                        </span>
                      </TextName>
                    </BlockName>

                    {departmentData?.message?.text &&
                      departmentData?.message?.text.map((item) => {
                        return (
                          <>
                            <DetailTop><p style={{ textIndent: '2em', marginBottom: '0em' }}>ยินดีต้อนรับนักศึกษาใหม่ทุกคน สู่รั้วแห่งความภาคภูมิใจของ สำนักวิชาพยาบาลศาสตร์ มหาวิทยาลัยเทคโนโลยีสุรนารีที่นี่ไม่ใช่เพียงสถานที่แห่งการเรียนรู้ แต่คือพื้นที่แห่งการเติบโตของหัวใจ ความคิด และจิตวิญญาณของความเป็น “พยาบาล”</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>สำนักวิชาพยาบาลศาสตร์มุ่งสร้างสรรค์นวัตกรรมทางการพยาบาล และผลิตบัณฑิตที่มีอัตลักษณ์ “ผู้มีภูมิรู้ ภูมิธรรม ภูมิปัญญา ภูมิฐาน และภูมิใจ” ภูมิรู้ในศาสตร์ ภูมิธรรมในจิตใจ ภูมิปัญญาในการตัดสินใจ ภูมิฐานในความเป็นมืออาชีพ และภูมิใจในคุณค่าของวิชาชีพ</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>การเรียนพยาบาลมิใช่เพียงการนั่งฟังบรรยายในห้องเรียน แต่คือการฝึกฝนอย่างเข้มข้น ทั้งภาคทฤษฎี การปฏิบัติในห้องปฏิบัติการทักษะ และการฝึกปฏิบัติกับผู้ป่วยจริงในโรงพยาบาลที่ได้มาตรฐานหลากหลายระดับเพราะ “หัวใจของหลักสูตรพยาบาล” คือการลงมือดูแลชีวิตมนุษย์อย่างแท้จริง</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>นักศึกษาจะได้เรียนรู้การประยุกต์องค์ความรู้สู่การดูแลแบบองค์รวมทั้งกาย ใจ สังคม และจิตวิญญาณ จึงจำเป็นต้องมีวินัย ความรับผิดชอบ และความตระหนักว่า ทุกการกระทำของเราเกี่ยวข้องกับชีวิตของผู้อื่น ดังพระราชดำรัสของ สมเด็จพระศรีนครินทราบรมราชชนนี ที่ว่า “เด็กๆ ต้องฝึกหัดอบรมทั้งกายทั้งใจให้เข้มแข็ง เป็นระเบียบ และสุจริต เพื่อประโยชน์ของตนในภายหน้า เพราะคนที่ไม่เข้มแข็ง ไม่สามารถควบคุมกายใจให้อยู่ในระเบียบและความดี ยากนักที่จะได้ประสบความสำเร็จและความเจริญอย่างแท้จริง”</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>วิชาชีพพยาบาลคือวิชาชีพแห่งเมตตา กรุณา และความเอื้ออาทร ทุกวันที่นักศึกษาออกฝึกปฏิบัติ จะได้รับรอยยิ้ม คำขอบคุณ และคำอวยพรจากผู้ป่วย ซึ่งมิใช่เพียงประสบการณ์การเรียนรู้ แต่คือการสร้างคุณค่าและความหมายให้กับชีวิตองค์ความรู้ที่ได้รับยังสามารถนำไปดูแลบิดา มารดา และครอบครัวของตนเองได้อีกด้วย</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>นอกจากนี้ สำนักวิชาฯ ยังส่งเสริมการใช้ผลงานวิจัยและนวัตกรรมในการพัฒนาการดูแลสุขภาพ สนับสนุนการเรียนรู้ความหลากหลายทางวัฒนธรรม และเปิดโลกสู่ความเป็นนานาชาติผ่านเครือข่ายความร่วมมือในเอเชีย ยุโรป และสหรัฐอเมริกา เพื่อหล่อหลอมบัณฑิตที่มีวิสัยทัศน์กว้างไกล ลึกซึ้ง และพร้อมรับใช้สังคมในทุกบริบท</p>
                              <p style={{ textIndent: '2em', marginBottom: '0em' }}>ขอให้นักศึกษาใหม่ทุกคนก้าวเดินด้วยหัวใจที่มุ่งมั่น เรียนรู้อย่างเต็มศักยภาพ เติบโตทั้งความรู้และความดี และในวันหนึ่ง จะได้ยืนอย่างสง่างามในฐานะ “พยาบาลมืออาชีพ” ที่สังคมเชื่อมั่น และตนเองภาคภูมิใจอย่างแท้จริง</p>
                            </DetailTop>

                          </>
                        );
                      })}
                  </Col>

                  {departmentData?.message?.image &&
                    departmentData?.message?.image.map((item) => {
                      return (
                        <>
                          <Col
                            span={11}
                            offset={1}
                            style={{
                              display: "flex",
                              alignItems: "baseline",
                            }}
                            className="col-image-profile"
                          >
                            <FadeInSection axis="y">
                              <img
                                loading="lazy"
                                src={item?.image_0}
                                alt="dean"
                                width={"100%"}
                              />
                            </FadeInSection>
                          </Col>
                          {item?.image_1 && item?.image_2 && (
                            <Player
                              poster={item?.image_1}
                              className="img-people"
                              autoPlay
                              muted
                              playsInline
                              src={item?.image_2}
                            >
                              <BigPlayButton position="center" />
                            </Player>
                          )}
                        </>
                      );
                    })}
                </Row>
              )}
            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={3}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      {departmentData?.contract[0]?.department}
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {/* ดึงข้อมูลหลักสูตรเดิมจากฐานข้อมูล */}
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={24} key={index}>
                          <Href
                            to={item?.slang}
                            rel="noopener noreferrer"
                            target={"_self"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}

                    {/* ---------------- เริ่มส่วนที่เพิ่มใหม่ ---------------- */}
                    <Col span={24}>
                      <a 
                        href="https://nurse.sut.ac.th/curriculum/%e0%b8%ab%e0%b8%a5%e0%b8%b1%e0%b8%81%e0%b8%aa%e0%b8%b9%e0%b8%95%e0%b8%a3%e0%b8%9e%e0%b8%a2%e0%b8%b2%e0%b8%9a%e0%b8%b2%e0%b8%a5%e0%b8%a8%e0%b8%b2%e0%b8%aa%e0%b8%95%e0%b8%a3%e0%b8%9a%e0%b8%b1%e0%b8%93-2/#" 
                        target="_blank" 
                        rel="noreferrer"
                        style={{ display: "inline-block", width: "100%", textDecoration: "none" }}
                      >
                        <NameCourse>
                          พยาบาลศาสตรบัณฑิตสำหรับผู้สำเร็จระดับปริญญาตรีสาขาอื่น (หลักสูตรใหม่ พ.ศ. 2569)
                        </NameCourse>
                      </a>
                    </Col>
                    {/* ---------------- สิ้นสุดส่วนที่เพิ่มใหม่ ---------------- */}
                  </Row>
                </Col>
              </Row>
            )}
            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={3}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                              item?.text_0 ===
                              "เรียนพยาบาล มทส. อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                              item?.text_1 ===
                              "เรียนแพทย์อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.curriculum && (
              <Element name={departmentData?.curriculum?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    {departmentData?.curriculum?.image ? (
                      departmentData?.curriculum?.image.map((item) => {
                        return (
                          <FadeInSection axis="y">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_3 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_3}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>

                  <Col span={12} offset={1}>
                    <SubTitle>{departmentData?.curriculum?.title}</SubTitle>

                    {departmentData?.curriculum?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail>{item?.text_0}</SubDetail>
                            
                          )}

                         

                          {/* ปรับแก้จากปุ่มเดียวเป็นสองปุ่มเรียงต่อกัน */}
                          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "20px" }}>
                            
                            {/* ปุ่มที่ 1: หลักสูตร 4 ปี */}
                            <div className="btn-view-info" style={{ marginTop: 0 }}>
                              <a
                                href="https://drive.google.com/file/d/1Ja7g4FSeV9bdMEqG9bSTLRRP6TcH0VRI/view"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <p>ดูข้อมูลหลักสูตร 4 ปี</p>
                              </a>
                            </div>

                            {/* ปุ่มที่ 2: หลักสูตร 2 ปี */}
                            <div className="btn-view-info" style={{ marginTop: 0 }}>
                              <a
                                href="https://drive.google.com/file/d/1Y0YKaWsrHIjMvAqrbgnruwPrR6ttYe8H/view"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <p>ดูข้อมูลหลักสูตร 2 ปี</p>
                              </a>
                            </div>

                          </div>
                        </>
                      );
                    })}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.study && (
              <>
                <Element name={departmentData?.study?.title}>
                  <FixBox bg={ListColor2[slang]}>
                    <SubTitle top="0">{departmentData?.study?.title}</SubTitle>
                    {departmentData?.study?.sub_title && (
                      <SubDetail indent="32">
                        {departmentData?.study?.sub_title}
                      </SubDetail>
                    )}
                    <Row
                      gutter={24}
                      className="row-detail-card"
                      justify="center"
                    >
                      {departmentData?.study?.data
                        .slice(1)
                        .map((item, index) => {
                          return (
                            <Col span={8} key={index}>
                              <CardDetail
                                src={item?.image}
                                detail={item?.detail}
                              />
                            </Col>
                          );
                        })}
                    </Row>
                  </FixBox>
                </Element>
              </>
            )}
            {departmentData?.criterion && departmentData?.criterion1 && (
              <Element name={departmentData?.criterion?.title}>
                <SubTitle>{departmentData?.criterion?.title}</SubTitle>
                <Row
                  gutter={24}
                  className="row-group"
                  style={{ marginTop: "10px" }}
                >
                  <Col span={11}>
                    {departmentData?.criterion?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && <SubHead>{item?.text_0}</SubHead>}
                          {item?.text_1 && (
                            <TextBold bottom="0">{item?.text_1}</TextBold>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && (
                            <TextBold bottom="0" top="0">
                              {item?.text_3}
                            </TextBold>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_7}
                            </SubDetail>
                          )}
                          {item?.text_8 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_8}
                            </SubDetail>
                          )}
                          {item?.text_9 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_9}
                            </SubDetail>
                          )}
                          {item?.text_10 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_10}
                            </SubDetail>
                          )}
                          {item?.text_11 && (
                            <SubDetail top="0" indent="35">
                              {item?.text_11}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.criterion1?.text.map((item) => {
                      return (
                        <>
                          {departmentData?.criterion1?.title && (
                            <SubHead>
                              {departmentData?.criterion1?.title}
                            </SubHead>
                          )}
                          {item?.text_0 && (
                            <TextBold bottom="0">{item?.text_0}</TextBold>
                          )}
                          {item?.text_1 && (
                            <TextBold bottom="0" top="0">
                              {item?.text_1}
                            </TextBold>
                          )}
                          {item?.text_2 && (
                            <TextBold bottom="0" top="0">
                              {item?.text_2}
                            </TextBold>
                          )}
                          {item?.text_3 && (
                            <TextBold bottom="0" top="0">
                              {item?.text_3}
                            </TextBold>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_4}
                            </SubDetail>
                          )}

                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" bottom="0">
                              {item?.text_7}
                            </SubDetail>
                          )}
                          {item?.text_8 && (
                            <SubDetail top="0">{item?.text_8}</SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                </Row>
              </Element>
            )}
            {departmentData?.teacher && (
              <Element name={departmentData?.teacher?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                      {departmentData?.teacher?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}

                            {item?.text_4 && (
                              <TextNote>{item?.text_4}</TextNote>
                            )}
                          </>
                        );
                      })}
                    </Col>

                    <Col span={12} offset={1}>
                      {departmentData?.teacher?.image ? (
                        departmentData?.teacher?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}
            {departmentData?.estermate && (
              <Element name={departmentData?.estermate?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    {departmentData?.estermate?.image ? (
                      departmentData?.estermate?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_3 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_3}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                  <Col span={11} offset={1}>
                    <SubTitle>{departmentData?.estermate?.title}</SubTitle>
                    {departmentData?.estermate?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0" indent="32">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" indent="32">
                              {item?.text_2}
                            </SubDetail>
                          )}
                          {item?.text_3 && <SubHead>{item?.text_3}</SubHead>}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {slang === "department-nursing"
                                ? spliteLink(item?.text_4, "1) Log in: ")
                                : item?.text_4}
                            </SubDetail>
                          )}
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_5}
                            </SubDetail>
                          )}
                          {item?.text_6 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_6}
                            </SubDetail>
                          )}
                          {item?.text_7 && (
                            <SubDetail top="0" indent="32">
                              {item?.text_7}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                </Row>
              </Element>
            )}
            {departmentData?.complaints_system && (
              <Element name={departmentData?.complaints_system?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={11}>
                      {departmentData?.complaints_system?.image ? (
                        departmentData?.complaints_system?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_3 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_3}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>

                    <Col span={12} offset={1}>
                      <SubTitle>
                        {departmentData?.complaints_system?.title}
                      </SubTitle>

                      {departmentData?.complaints_system?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail>{item?.text_0}</SubDetail>
                            )}

                            <div className="btn-view-info">
                              <a
                                href="https://nurse.sut.ac.th/about-us/voc/"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <p>ไปหน้าระบบ</p>
                              </a>
                            </div>
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}
            {departmentData?.vow && (
              <Element name={departmentData?.vow?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.vow?.title}</SubTitle>
                    {departmentData?.vow?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0" indent="35">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail bottom="0" top="0" indent="35">
                              {item?.text_1}
                            </SubDetail>
                          )}
                          {item?.text_2 && (
                            <SubDetail top="0" indent="35">
                              {item?.text_2}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>
                  <Col span={12} offset={1}>
                    {departmentData?.vow?.image ? (
                      departmentData?.vow?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </Element>
            )}
            {departmentData?.song && (
              <Element name={departmentData?.song?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={24}>
                      <SubTitle align="center">
                        {departmentData?.song?.title}
                      </SubTitle>
                      {departmentData?.song?.text.map((item) => {
                        return (
                          <>
                            <SubDetail align="center">
                              {item?.text_0 && item?.text_0} <br />
                              {item?.text_1 && item?.text_1} <br />
                              {item?.text_2 && item?.text_2}
                              <br />
                              {item?.text_3 && item?.text_3} <br />
                              {item?.text_4 && item?.text_4} <br />
                              {item?.text_5 && item?.text_5} <br />
                              {item?.text_6 && item?.text_6} <br />
                              {item?.text_7 && item?.text_7} <br />
                              {item?.text_8 && item?.text_8} <br />
                              {item?.text_9 && item?.text_9} <br />
                              {item?.text_10 && item?.text_10} <br />
                              {item?.text_11 && item?.text_11} <br />
                              {item?.text_12 && item?.text_12} <br />
                              {item?.text_13 && item?.text_13} <br />
                              {item?.text_14 && item?.text_14} <br />
                              {item?.text_15 && item?.text_15} <br />
                              {item?.text_16 && item?.text_16} <br />
                              {item?.text_17 && item?.text_17}
                            </SubDetail>
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}
            {departmentData?.Regulations && (
              <Element name={departmentData?.Regulations?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    {departmentData?.Regulations?.image ? (
                      departmentData?.Regulations?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                  <Col span={12} offset={1}>
                    <SubTitle>{departmentData?.Regulations?.title}</SubTitle>
                    <SubDetail bottom="0">
                      ชวนน้อง ๆ มาอ่านกันข้อบังคับที่ควรรู้กัน
                    </SubDetail>
                    {departmentData.Regulations.link &&
                      departmentData.Regulations.link[0].link_0 && (
                        <div
                          className="btn-view-info"
                          style={{ width: "338px", marginTop: "25px" }}
                        >
                          <a
                            href={departmentData.Regulations.link[0].link_0}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p>อ่านฉบับแรก ปี พ.ศ. 2566</p>
                          </a>
                        </div>
                      )}
                    {departmentData.Regulations.link &&
                      departmentData.Regulations.link[0].link_1 && (
                        <div
                          className="btn-view-info"
                          style={{ width: "359px" }}
                        >
                          <a
                            href={departmentData.Regulations.link[0].link_1}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <p>อ่านฉบับที่สอง ปี พ.ศ. 2567</p>
                          </a>
                        </div>
                      )}
                  </Col>
                </Row>
              </Element>
            )}
            
            {departmentData?.Expected_learning && (
              <Element name={departmentData?.Expected_learning?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    
                    {/* ---------------- รูปภาพ (ฝั่งซ้าย) ---------------- */}
                    <Col span={12}>
                      <FadeInSection axis="y">
                        <Row gutter={[12, 12]} wrap={false} style={{ width: "100%", overflowX: "auto" }}>
                          {departmentData?.Expected_learning?.image ? (
                            departmentData?.Expected_learning?.image.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  {item?.image_0 && (
                                    <Col flex={1}>
                                      <img
                                        loading="lazy"
                                        src={item?.image_0}
                                        alt="Expected learning 0"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover"
                                        }}
                                      />
                                    </Col>
                                  )}
                                  {item?.image_1 && (
                                    <Col flex={1}>
                                      <img
                                        loading="lazy"
                                        src={item?.image_1}
                                        alt="Expected learning 1"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover"
                                        }}
                                      />
                                    </Col>
                                  )}
                                  {item?.image_2 && (
                                    <Col flex={1}>
                                      <img
                                        loading="lazy"
                                        src={item?.image_2}
                                        alt="Expected learning 2"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover"
                                        }}
                                      />
                                    </Col>
                                  )}
                                  {item?.image_3 && (
                                    <Col flex={1}>
                                      <img
                                        loading="lazy"
                                        src={item?.image_3}
                                        alt="Expected learning 3"
                                        style={{
                                          borderRadius: "20px",
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover"
                                        }}
                                      />
                                    </Col>
                                  )}
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <Col flex={1}>
                              <img
                                loading="lazy"
                                src={engineer}
                                alt="icon group"
                                style={{ borderRadius: "20px", width: "100%" }}
                              />
                            </Col>
                          )}
                        </Row>
                      </FadeInSection>
                    </Col>

                    {/* ---------------- ตัวหนังสือ (ฝั่งขวา) ---------------- */}
                    <Col span={11} offset={1}>
                      <SubTitle>
                        {departmentData?.Expected_learning?.title}
                      </SubTitle>
                      {departmentData?.Expected_learning?.text.map((item, index) => {
                        return (
                          <React.Fragment key={`text-${index}`}>
                            {item?.text_0 && (
                              <SubDetail bottom="0">{item?.text_0}</SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0">{item?.text_3}</SubDetail>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </Col>

                  </Row>
                </FixBox>
              </Element>
            )}
            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"white"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                          return (
                            <Col
                              span={12}
                              style={{ padding: "10px" }}
                              key={index}
                            >
                              <div style={styleDetailContact}>
                                <DetailContact
                                  color="var(--black)"
                                  title={item?.title}
                                  phone={item?.phone_1}
                                  office={item?.phone_2}
                                  facebook={item?.fb}
                                  website={item?.site}
                                  email1={item?.email_1}
                                  email2={item?.email_2}
                                  email3={item?.email_3}
                                  line={item?.line}
                                  indent={"40"}
                                  slang={slang}
                                  type="branch"
                                  titleWebsite="เว็บไซต์สำนักวิชา"
                                />
                              </div>
                            </Col>
                          );
                        })
                        : contactData[0]?.address !== "" && (
                          <Col span={12} style={{ padding: "10px" }}>
                            <DetailContact
                              color="var(--black)"
                              title={contactData[0]?.title}
                              address={contactData[0]?.address}
                              slang={slang}
                              type="branch"
                            />
                          </Col>
                        )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}
            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead weight="bold">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>ตั้งแต่เริ่มเปิดเว็บไซต์</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>ปี (พ.ศ.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
}

export default NursingDepartment;
